export default __webpack_public_path__ + "static/media/defiPlatformBanner.c5b1426d.png";